export default __webpack_public_path__ + "static/media/yellow-vaccine-lg.08e57a11.svg";